
import { Language } from '@/types/language';

export function isValidLanguage(lang: string): lang is Language {
  return ['en', 'es', 'fr', 'de', 'zh', 'ja', 'ko', 'ar', 'it', 'fi', 'he'].includes(lang);
}

export const getPreferredLanguage = (): Language => {
  console.log('Detecting preferred language...');
  
  try {
    // First check localStorage
    const saved = localStorage.getItem('preferredLanguage');
    if (saved && isValidLanguage(saved)) {
      console.log('Using saved language preference:', saved);
      return saved as Language;
    }

    // Then check browser language
    const browserLang = navigator.language.split('-')[0].toLowerCase();
    console.log('Browser language detected:', browserLang);
    
    if (isValidLanguage(browserLang)) {
      console.log('Browser language is supported, using:', browserLang);
      // Save this to localStorage for future visits
      localStorage.setItem('preferredLanguage', browserLang);
      return browserLang;
    }
    
    console.log('Browser language not supported, defaulting to English');
    // Set default in localStorage
    localStorage.setItem('preferredLanguage', 'en');
  } catch (error) {
    console.error('Error detecting language preference:', error);
    // In case of any errors, default to English
  }
  
  return 'en';
};

export const setHtmlAttributes = (language: Language) => {
  document.documentElement.lang = language;
  document.documentElement.dir = language === 'ar' || language === 'he' ? 'rtl' : 'ltr';
  
  // Add a data attribute to the HTML element for CSS targeting based on language
  document.documentElement.setAttribute('data-language', language);
  
  // Update the language in localStorage to ensure persistence
  localStorage.setItem('preferredLanguage', language);
  
  console.log(`HTML attributes set for ${language}, direction: ${language === 'ar' || language === 'he' ? 'rtl' : 'ltr'}`);
};
